import { useCallback, useState } from "react";
import { useQzTrayClient } from "./useQzTrayClient";
import { useQzTrayPrint } from "./useQzTrayPrint";
import useAlerts from "../useAlerts";
import { BackendQzPayloadAdapter } from "../../utils/qztray/BackendQzPayloadAdapter";

export const useQzTrayPrinter = () => {
  const {
    print,
    printers,
    isConnected,
    connectClient,
    discoverPrinters,
  } = useQzTrayClient();

  const { payload } = useQzTrayPrint();
  const { show: showAlert } = useAlerts();

  const [isPrinting, setIsPrinting] = useState(false);

  const printFromPayload = useCallback(async () => {
    try {
      if (!payload) {
        showAlert("warning", "Sin datos", "No hay payload disponible para imprimir.");
        return;
      }

      if (!isConnected) {
        await connectClient();
      }

      let availablePrinters = printers;

      if (!availablePrinters || availablePrinters.length === 0) {
        availablePrinters = await discoverPrinters();
      }

      if (!availablePrinters || availablePrinters.length === 0) {
        showAlert("error", "Sin impresoras", "QZ Tray no detectó impresoras instaladas.");
        return;
      }

      const backendPrinter = payload.printer?.trim();

      if (!backendPrinter) {
        showAlert(
          "warning",
          "Impresora no asignada",
          "La sucursal no tiene una impresora configurada."
        );
        return;
      }

      const printerExists = availablePrinters.includes(backendPrinter);

      if (!printerExists) {
        showAlert(
          "warning",
          "Impresora no encontrada",
          `La impresora asignada (${backendPrinter}) no está instalada o no fue detectada por QZ Tray.`
        );
        return;
      }

      const rawCommands = BackendQzPayloadAdapter.toRawEscPos(payload);

      setIsPrinting(true);

      await print(backendPrinter, rawCommands);

      showAlert(
        "success",
        "Impresión exitosa",
        `Ticket enviado a ${backendPrinter}`
      );
    } catch (err: any) {
      console.error("❌ Error al imprimir:", err);

      showAlert(
        "error",
        "Error de impresión",
        err?.message || "Falló la impresión."
      );
    } finally {
      setIsPrinting(false);
    }
  }, [
    payload,
    printers,
    isConnected,
    connectClient,
    discoverPrinters,
    print,
    showAlert,
  ]);

  return {
    printFromPayload,
    isPrinting,
  };
};